
import { useParams, useSearchParams } from 'react-router-dom'
import { ListKeys, salutationList } from '../../../api/list'
import { FormBuilderContainer } from '../../../components/formBuilder/formBuilder.container'
import { FormItemTypes, IFormBuilder, ValueTypes } from '../../../components/formBuilder/formBuilder.entity'
import { createUser, getUserbyId, updateUser } from './apiCall'
import { UserKeys } from './entity'

function UserEdit() {
  let { id } = useParams();
  const [searchParams] = useSearchParams();
  let mode = searchParams.get('mode') || id ? 'edit' : 'add';

  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.SearchSelect,
      name: 'HonorificPrefix',
      label: 'Honorific Prefix',
      displayExpr: "Name",
      getListData: salutationList,
      apiKey: ListKeys.salutation,
      required: true,
    },
    {
      type: FormItemTypes.TextInput,
      name: 'GivenName',
      label: 'Given Name',
      required: true,
      maxLength: 50,
    },
    {
      type: FormItemTypes.TextInput,
      name: 'FamilyName',
      label: 'Family Name',
      required: true,
      maxLength: 50,
    },
    {
      type: FormItemTypes.TextInput,
      name: 'AlternateName',
      label: 'Alternate Name',
      maxLength: 50,
    },
    {
      type: FormItemTypes.NumberInput,
      name: 'MobileNumber',
      label: 'Mobile Number',
      required: true,
      inputMode: 'tel',
      valueTypes: ValueTypes.mobile,
    },
    {
      type: FormItemTypes.TextInput,
      name: 'Email',
      label: 'Email',
      required: true,
      inputMode: 'email',
      valueTypes: ValueTypes.email
    },

    {
      type: FormItemTypes.Card,
      name: 'LoginInfo',
      label: 'Login Info',
      itemSize: 12,
      elements: [
        {
          type: FormItemTypes.TextInput,
          name: 'Username',
          label: 'Username',
          required: true,
          maxLength: 100,
          valueTypes: ValueTypes.noSpace,
          disabled: Boolean(id)
        },
        {
          type: FormItemTypes.Password,
          name: 'Password',
          label: 'Password',
          // required: true,
          maxLength: 15,
          valueTypes: ValueTypes.password,
          disabled: Boolean(id)
        },
        {
          type: FormItemTypes.Password,
          name: 'ConfirmPassword',
          label: 'Confirm Password',
          // required: true,
          maxLength: 15,
          valueTypes: ValueTypes.confirmPassword,
          disabled: Boolean(id)
        },
      ]
    }
  ]

  return (
    <FormBuilderContainer
      formData={formData}
      mode={mode}

      getFormAPI={getUserbyId}
      getRequest={{ id: id }}
      getKey={UserKeys.get}

      createFormAPI={createUser}
      createKey={UserKeys.create}

      updateFormAPI={updateUser}
      updateKey={UserKeys.update}

      headerLabel={mode === 'add' ? 'Add User' : 'User'}
      parentPath='/user'
    />
  )
}

export default UserEdit